import Grid from '@mui/material/Grid';
import TimeRangePicker from '../../../../components/common/TimeRangePicker';
import CustomInput from '../../../../components/CustomInput';

const TimeIntervalItem = (props) => {
  return (
    <>
      <Grid item>
        <CustomInput
          name="name"
          label="Name"
          clearFieldIcon={true}
          value={props.item.title}
          onChange={props.onChangeName}
        />
      </Grid>

      <TimeRangePicker selected={props.item.value} onChange={props.onChangeRange} helperText={props.helperText} />
    </>
  );
};

export default TimeIntervalItem;
